import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Typography, Button } from 'antd';
import { XInfoLabel } from '@/components/xqxc_ui';
import SetArea from './modal/SetInfo';
import model from '@/reducers/system/operation/model';
import { XTitle } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const { Title } = Typography;

const FinancialInfo = ({
    setBreadcrumbPaths,
    match,
    getSystemOperationInfo,
    systemOperationInfo: {
        companyBaseInfo = {},
        companyFinancialBaseInfo = {},
        companyFinancialBaseInfo: {
            bankAccount = '',
            bankName = '',
            openBank = '',
            bankAccountName = '',
        } = {}
    } = {}
}) => {

    const [renderMode, setRenderMode] = useState(false);
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        getSystemOperationInfo();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    useEffect(() => {
        if (update) {
            setUpdate(false);
            getSystemOperationInfo();
        }
    }, [update]);

    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const infoStyle = {
        paddingLeft: '20px'
    };

    const setInfo = () => {
        setRenderMode(true);
    };

    return <div style={container}>
        <XTitle style={{ marginBottom: '10px' }} label='财务信息' />
        <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='银行账户：' value={bankAccount} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='开户行：' value={bankName} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='银行：' value={openBank} />
            </Col>
            <Col span={24}>
                <XInfoLabel style={infoStyle} label='户名：' value={bankAccountName} />
            </Col>
            <Col span={24}>
                <Button type='primary' onClick={setInfo}>设置信息</Button>
            </Col>
        </Row>
        {renderMode && <SetArea setUpdate={setUpdate} setRenderMode={setRenderMode} companyFinancialBaseInfo={companyFinancialBaseInfo} companyBaseInfo={companyBaseInfo} />}
    </div>;
};

FinancialInfo.propTypes = {
    getSystemOperationInfo: PropTypes.func,
    systemOperationInfo: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect((state) => ({
    systemOperationInfo: state.systemOperation.systemOperationInfo,
}), {
    setBreadcrumbPaths,
    ...model.actions
})(FinancialInfo);